export const MOCK_SITE_SAMPLE_IDS = {
  default: "0",
  optimisation_amber: "1",
  optimisation_tou: "2",
  notification_backup: "3",
};